<app-prodotti-varianti [isVendor]="true"
                       [pVenditaID]= "data.pVenditaID"
                       [vendorSlug]="data.vendorSlug"
                       [pVariant]="data.pVariant"
                       [pVariantIds]="data.pVariantIds"
                       [excludeNotOrdered]="data.excludeNotOrdered"
                       [isPVendita]="true"
                       [isModal]="data.isModal"
                       (eventEmitter)="addPVariantInstance($event)"></app-prodotti-varianti>
